import * as React from 'react';
import {
  Box, Typography,
  Accordion, AccordionDetails, AccordionSummary,
} from '@mui/material';
import PropTypes from 'prop-types';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { ReportSetAccordion } from './PlugStyles';
import TestCard from './TestCard';
import { getFormatDateLabel, getFormatTime } from '../../../helpers/miscHelpers';

const getTestCount = (packages) => {
  let totalTestNamesCount = 0;
  for (const packageItem of packages) {
    if (packageItem.testNames) {
      totalTestNamesCount += packageItem.testNames.length;
    }
  }
  return totalTestNamesCount;
};

const ReportSetsAccordion = ({
  panel, setPanel, order, number, id,
}) => {
  const reportCount = getTestCount(order?.packages);

  return (
    <Accordion
      sx={panel === `${number}${id}${order?.reportTat}` ? ReportSetAccordion.AccordionExpanded : ReportSetAccordion.Accordion}
      elevation={0}
      expanded={panel === `${number}${id}${order?.reportTat}`}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreRoundedIcon sx={ReportSetAccordion.ArrowIcon} />}
        sx={ReportSetAccordion.AccordionSummary}
        onClick={() => {
          if (panel !== `${number}${id}${order?.reportTat}`) {
            setPanel(`${number}${id}${order?.reportTat}`);
          } else {
            setPanel('');
          }
        }}
      >
        <Box sx={ReportSetAccordion.ReportCardHeader}>
          <Box>
            <Box sx={ReportSetAccordion.AccordionSummaryBox}>
              <Typography
                sx={ReportSetAccordion.SetNumber}
              >
                Report Set #{number}
              </Typography>
            </Box>
            <Box sx={ReportSetAccordion.TimingContainer}>
              <Typography
                sx={ReportSetAccordion.Date}
              >
                { getFormatDateLabel(order?.reportTat) }
              </Typography>
              <Typography
                sx={ReportSetAccordion.Dot}
              >
                •
              </Typography>
              <Typography
                sx={ReportSetAccordion.Time}
              >
                { getFormatTime(order?.reportTat) }
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography
              sx={ReportSetAccordion.Report}
            >
              {`${reportCount} ${reportCount > 1 ? 'Reports' : 'Report'}`}
            </Typography>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={ReportSetAccordion.AccordionDetails}>
        {order.packages.map((item, i) => (
          <>
            <Box key={`${item.id}${item.packageName}`}>
              <TestCard testType={item.packageName} testNames={item.testNames} />
            </Box>
            {order.packages.length - 1 !== i && <Box sx={ReportSetAccordion.Divider} />}
          </>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

ReportSetsAccordion.propTypes = {
  order: PropTypes.any,
  number: PropTypes.number,
  panel: PropTypes.string,
  setPanel: PropTypes.func,
  id: PropTypes.number,
};

export default ReportSetsAccordion;
